module.exports = __webpack_public_path__ + "media/tacklebox/assets/images/views/advertisements/yahoo-ae93745558206bdbc50c8b04fed051bb.png";